
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VAutocomplete from 'vuetify/lib/components/VAutocomplete/VAutocomplete';
import Vue, { CreateElement, VNode } from 'vue';
const base = Vue.extend({ mixins: [VAutocomplete] });
export default base.extend({
    name: 'de-emphasized-select',
    props: {
        // set filled false, as this is the select style we want for de-emphasized selects
        filled: {
            type: Boolean,
            default: false
        },
        // set default menu options
        menuProps: {
            type: [String, Array, Object],
            default: () => ({
                transition: 'slide-x-transition'
            }) as Record<string, any>
        },
        appendIcon: {
            type: String,
            default(): string {
                return 'fa-solid fa-chevron-down';
            }
        },
        height: {
            type: [Number, String],
            default: undefined
        },
        fullWidth: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: undefined
        },
        label: {
            type: String,
            default: ''
        }
    },
    computed: {
        classes(): object {
            return {
                ...VAutocomplete.options.computed.classes.call(this),
                'base-select': true,
                'de-emphasized-select': true
            };
        }
    },
    render(h: CreateElement): VNode {
        const commonProps = {
            ...this.$props,
            filled: this.filled,
            appendIcon: this.appendIcon,
            height: this.height,
            fullWidth: this.fullWidth,
            placeholder: this.placeholder,
            label: ''
        };

        const autocomplete = h(
            VAutocomplete,
            {
                class: this.classes,
                props: commonProps,
                on: this.$listeners,
                scopedSlots: this.$scopedSlots,
                attrs: this.$attrs
            },
            this.$slots.default
        );

        return h('div', { class: 'select-wrapper' }, [
            this.label ? h('div', { class: 'select-title' }, this.label) : null,
            autocomplete
        ]);

    }
});
